import { PermissionComponent } from "../../components";

export default function RoleUsersPage() {
  return <PermissionComponent.RolesPage.RoleUserPage />;
}
